import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
// Angular Imports
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
// This Module's Components
import { RefundableFlightsComponent } from './refundable-flights.component';

@NgModule({
  imports: [CommonModule, HttpClientModule, ModalModule.forRoot()],
  declarations: [RefundableFlightsComponent],
  exports: [RefundableFlightsComponent]
})
export class RefundableFlightsModule {}
